import { render } from "./messageCard.vue?vue&type=template&id=f1e22056&scoped=true"
import script from "./messageCard.vue?vue&type=script&lang=js"
export * from "./messageCard.vue?vue&type=script&lang=js"

import "./messageCard.vue?vue&type=style&index=0&id=f1e22056&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1e22056"]])

export default __exports__